var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Grid',{attrs:{"size":"6"}},_vm._l((_vm.results),function(artist){return _c('GridItem',{key:artist.id,attrs:{"url":("/artists/" + (artist.url_key)),"image":_vm.getImage(artist),"title_one":artist.title,"small":true}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }